// extracted by mini-css-extract-plugin
module.exports = {"M":"location_M__Y24mk","Location":"location_Location__1a-zN"};